import { format, formatDistanceToNowStrict } from 'date-fns';
import React, { useState } from 'react';
import { formatNumberShort, parseUTC } from '../../../../../lib/utils/format';
import formatDistance from '../../../../../lib/utils/formatDistance';
import Button from '../../../../Button';
import ViewMessageUsersModal from '../../../../Modals/ViewMessageUsersModal/ViewMessageUsersModal';

export default function MessageStats({ message, messageLink }) {
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState('');

  const likeCount = (message.likes || []).filter((l) => l.marked).length;

  const insightCount = (message.insights || []).filter((l) => l.marked).length;

  const freshCount = (message.freshs || []).filter((l) => l.marked).length;

  const date = message.inserted_at && format(parseUTC(message.inserted_at), 'dd/MM/yyyy');

  const timeStamp =
    message.inserted_at &&
    formatDistanceToNowStrict(parseUTC(message.inserted_at), {
      locale: { formatDistance },
    });

  const handleOpen = (newType) => {
    setIsOpen(true);
    setType(newType);
  };

  return (
    <section className="msg-stats">
      {!!likeCount && (
        <Button variant="clear" className="stat" onClick={() => handleOpen('like')}>
          <strong>{formatNumberShort(likeCount)}</strong> {likeCount === 1 ? 'like' : 'likes'}
        </Button>
      )}
      {!!insightCount && (
        <Button variant="clear" className="stat" onClick={() => handleOpen('insight')}>
          <strong>{formatNumberShort(insightCount)}</strong> {insightCount === 1 ? 'user' : 'users'}{' '}
          thought this was insightful
        </Button>
      )}
      {!!freshCount && (
        <Button variant="clear" className="stat" onClick={() => handleOpen('fresh')}>
          <strong>{formatNumberShort(freshCount)}</strong> {freshCount === 1 ? 'user' : 'users'}{' '}
          thought this was fresh
        </Button>
      )}
      <Button as="a" href={messageLink} variant="clear" className="group msg-timestamps">
        <span className="items">{timeStamp}</span>
        <span className="spacer">·</span>
        <span className="items">{date}</span>
      </Button>
      <ViewMessageUsersModal
        type={type}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        message={message}
      />
    </section>
  );
}
